import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewSidelane = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 30 30" {...props}>
    <path fill="#383864" fillRule="evenodd" d="M11 19h8v-8h-8v8Z" clipRule="evenodd" />
    <path fill="#383864" fillRule="evenodd" d="M30 30V2.344l-5.303 5.303v17.05H7.647L2.344 30H30Z" clipRule="evenodd" />
    <path fill="currentColor" fillRule="evenodd" d="M0 0v27.656l5.303-5.303V5.303h17.05L27.656 0H0Z" clipRule="evenodd" />
  </svg>
);
